<label class="mat-optgroup-label" [id]="_labelId">{{ label }}</label><ng-content select="mat-option, ng-container"></ng-content>